import { Card, CardBody, Input } from '@heroui/react';
import { produce } from 'immer';
import _ from 'lodash';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function MultiNumInput({ answerHistory, data, sendAnswer, options }) {
  const { t } = useTranslation('survey');

  const initAnswer = answerHistory || new Array(data.length).fill(null);
  const [answers, setAnswer] = useState(initAnswer);

  const [errorFields, setErrorFields] = useState(
    new Array(data.length).fill(null)
  );

  const validateNumber = useCallback((value, i) => {
    setErrorFields(
      produce((draft) => {
        draft[i] = '';
      })
    );

    const { limitMin, limitMax } = data[i].options;
    const minNumber = _.toNumber(limitMin);
    const maxNumber = _.toNumber(limitMax);

    if (_.isNaN(_.toNumber(value))) {
      setErrorFields(
        produce((draft) => {
          draft[i] = t('numinput.error.invalid');
        })
      );
      return false;
    }

    if (!_.isNil(minNumber) && value < minNumber) {
      setErrorFields(
        produce((draft) => {
          draft[i] = t('numinput.error.min', { value: minNumber });
        })
      );
      return false;
    }
    if (maxNumber && value > maxNumber) {
      setErrorFields(
        produce((draft) => {
          draft[i] = t('numinput.error.max', { value: maxNumber });
        })
      );
      return false;
    }

    return true;
  }, []);

  const handleInputChange = (value, i) => {
    const answersCopy = [...answers];
    const valid = validateNumber(value, i);

    if (!valid) {
      answersCopy[i] = null;
      setAnswer(answersCopy);
      sendAnswer(answersCopy);
    } else {
      answersCopy[i] = _.toNumber(value);
      setAnswer(answersCopy);
      sendAnswer(answersCopy);
    }
  };

  return (
    <>
      {data.map((item, i) => (
        <Card className="max-w-md" key={item.text}>
          <CardBody>
            <Input
              color="primary"
              defaultValue={!_.isNil(answers[i]) ? answers[i] : null}
              endContent={
                <div className="flex items-center">
                  <span>{options.unit}</span>
                </div>
              }
              errorMessage={errorFields[i]}
              isInvalid={!_.isEmpty(errorFields[i])}
              label={item.text}
              onChange={(e) => handleInputChange(e.target.value, i)}
              size="lg"
              type="number"
              variant="underlined"
            />
          </CardBody>
        </Card>
      ))}
    </>
  );
}
